import React, { useMemo } from "react";
import { Col, Row, Table, Button } from "react-bootstrap";
import { chunkArray } from "../../../../utils/array";
import { HugeiconsIcon } from "@hugeicons/react";
import { PencilEdit02Icon } from "@hugeicons/core-free-icons";

export default function UserDetailsTable({ userData, entity, docs, onEditMobile, onEditEmail, categoryType, userCategoryMain }) {
  const idTypeReadableMap = {
    aadhaar: "Aadhaar Card",
    aadhaar_card: "Aadhaar Card",
    aadhar: "Aadhaar Card",
    pan: "PAN Card",
    pan_card: "PAN Card",
    driving_license: "Driving License",
    driving_licence: "Driving License",
    voter_id: "Voter ID",
    passport: "Passport",
    birth_certificate: "Birth Certificate",
    tenth_identity: "10th Marksheet",
  };

  const getDocByName = (docName) =>
    docs?.find(
      (d) => (d?.doc_name || "").toLowerCase() === (docName || "").toLowerCase()
    );

  const fullName = useMemo(
    () => [userData?.first_name, userData?.middle_name, userData?.last_name].filter(Boolean).join(" "),
    [userData?.first_name, userData?.middle_name, userData?.last_name]
  );

  const identificationType = idTypeReadableMap[entity?.identity_type] || entity?.identity_type || "NA";
  const idDoc = getDocByName(entity?.identity_type || "aadhaar");
  const sportsDoc = getDocByName("sports_achievement");

  const highestQual = entity?.education_level;
  const eduDoc = getDocByName(highestQual);
  console.log({ highestQual, eduDoc })

  const isSupportStaff = String(categoryType) === '2' && String(userCategoryMain) === '1';
  const orgProfile = userData?.organization_profile || {};
  const isInstitution = String(userCategoryMain) === '2';

  let personalDetails = {};

  if (isInstitution) {
    personalDetails = {
      "Center Phone Number": userData?.organization?.mobile || "NA",
      "Sports Offered": userData?.organization?.sports_offered || "NA",
      "Center Contact Person Name": userData?.organization?.contact_person_name || "NA",
      "Center Name": userData?.name_of_legel_entity || userData?.organization?.name_of_organization || "NA",
      "Center Type": userData?.center_type || "NA",
      "Center District": userData?.organization?.city_name || "NA",
    };
  } else {
    personalDetails = {
      "Full Name": fullName || "NA",
      Gender: entity?.gender === "M" ? "Male" : entity?.gender === "F" ? "Female" : entity?.gender || "NA",
      "Email ID": userData?.email || "NA",
      "Mobile Number": entity?.mobile || "NA",
      Identification: identificationType,
      "Identification Document": idDoc?.doc_file || "NA",
      "Highest Qualification": highestQual || "NA",
      ...(isSupportStaff && { "Marital Status": entity?.maritial_status || "NA" }),
      [isSupportStaff ? "Sport" : "Sports Certificate"]: [isSupportStaff ? entity?.ref_sport?.sport_name : <a href={sportsDoc?.doc_file} target="_blank" rel="noopener noreferrer" className="doc-link">Sports Certificate</a>] || "NA",
      ...(!isSupportStaff && {
        "Kit Size": entity?.kit_size_name || "NA",
      }),
      Landmark: entity?.landmark || "NA",
      Country: entity?.country_name || "NA",
      State: entity?.state_name || "NA",
      City: entity?.city_name || "NA",
      Pincode: entity?.pincode || "NA",
      DOB: entity?.dob || "NA",
      "Full Address": entity?.address || "NA",
    };
  }

  const detailEntries = Object.entries(personalDetails);
  const chunkedRows = chunkArray(detailEntries, 3);

  // Center Details Logic

  let centerDetails = {};

  if (!isInstitution) {
    centerDetails = {
      ...(!isSupportStaff && {
        "Center District": orgProfile.city_name || "NA",
        "Center Type": orgProfile.parent?.sub_category_name || "NA",
        "Center Name": userData?.center_name || "NA",
      }),
      ...(isSupportStaff && {
        "Center Country": orgProfile.country_name || "NA",
        "Center State": orgProfile.state_name || "NA",
        "Center District": orgProfile.city_name || "NA",
        "Center Type": orgProfile.parent?.sub_category_name || "NA",
        "Center Name": userData?.center_name || "NA",
      })
    };
  }
  const centerEntries = Object.entries(centerDetails);
  const chunkedCenterRows = chunkArray(centerEntries, 3);

  // Bank Details Logic
  let bankDetails = {};
  const bankDoc = getDocByName("cancelled_cheque_or_passbook");

  if (!isInstitution) {
    bankDetails = {
      "Bank Name": entity?.bank_name || "NA",
      "Account Holder Name": entity?.account_holder_name || "NA",
      "Account Number": entity?.bank_account_number || "NA",
      "Branch Name": entity?.branch_name || "NA",
      "IFSC Code": entity?.ifsc_code || "NA",
      // "Cancelled Cheque/Passbook": bankDoc?.doc_file ? (
      //   <a href={bankDoc.doc_file} target="_blank" rel="noopener noreferrer" className="doc-link">
      //     View Document
      //   </a>
      // ) : "NA"
    };
  }

  const bankEntries = Object.entries(bankDetails);
  const chunkedBankRows = chunkArray(bankEntries, 3);

  return (
    <Row className="user-details-table-row">
      <Col md={12}>
        <Table borderless size="sm" className="user-details-table mb-0">
          <tbody>
            {chunkedRows.map((row, rowIndex) => (
              <tr key={`personal-${rowIndex}`} className="user-details-table-row-item">
                {row.map(([label, value], colIndex) => {
                  let displayValue = value;

                  if (label === "Identification") {
                    displayValue = identificationType;
                  }

                  if (label === "Identification Document") {
                    const isUrl = typeof value === "string" && value.startsWith("http");
                    displayValue = isUrl ? (
                      <a href={value} target="_blank" rel="noopener noreferrer" className="doc-link">
                        {identificationType}
                      </a>
                    ) : (
                      value || "NA"
                    );
                  }

                  if (label === "Sports Certificate" || label === "Sport") {
                    const isUrl = typeof value === "string" && value.startsWith("http");
                    displayValue = isUrl ? (
                      <a href={value} target="_blank" rel="noopener noreferrer" className="doc-link">
                        {label === "Sport" ? "View Sport Certificate" : "Sports Certificate"}
                      </a>
                    ) : (
                      value || "NA"
                    );
                  }

                  if (label === "Highest Qualification") {
                    const qualificationMap = {
                      tenth: "10th Standard",
                      twelfth: "12th Standard",
                      ug: "Under Graduate",
                      pg: "Post Graduate",
                      phd: "PhD",
                      tc: "Transfer Certificate"
                    };
                    const displayQual = qualificationMap[value] || value?.toUpperCase() || "NA";

                    displayValue = eduDoc?.doc_file ? (
                      <a href={eduDoc.doc_file} target="_blank" rel="noopener noreferrer" className="doc-link">
                        {displayQual}
                      </a>
                    ) : (
                      displayQual
                    );
                  }

                  const isEditableMobile = label === "Mobile Number" || label === "Center Phone Number";
                  const isEditableEmail = false;

                  return (
                    <td key={colIndex} style={{ width: "33.33%" }} className="user-detail-cell py-3">
                      <h5 className="detail-label mb-2">{label}</h5>
                      {isEditableMobile || isEditableEmail ? (
                        <div className="d-flex align-items-center justify-content-between gap-2">
                          <div className="detail-value">{displayValue || "NA"}</div>
                          <Button
                            variant="light"
                            size="sm"
                            onClick={isEditableMobile ? onEditMobile : onEditEmail}
                            className="edit-btn d-inline-flex align-items-center gap-1"
                          >
                            <span className="icon"><HugeiconsIcon icon={PencilEdit02Icon} size={16} /></span>
                            <span>Edit</span>
                          </Button>
                        </div>
                      ) : (
                        <div className="detail-value">{displayValue || "NA"}</div>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}

            {/* Centre Details Section */}
            {userData?.organization_profile && !isInstitution && (
              <>
                <tr>
                  <td colSpan="3" className="pt-4 pb-2">
                    <h5 className="user-header mb-0 text-black">Centre Details</h5>
                  </td>
                </tr>
                {chunkedCenterRows.map((row, rowIndex) => (
                  <tr key={`center-${rowIndex}`} className="user-details-table-row-item">
                    {row.map(([label, value], colIndex) => (
                      <td key={colIndex} style={{ width: "33.33%" }} className="user-detail-cell py-3">
                        <h5 className="detail-label mb-2">{label}</h5>
                        <div className="detail-value">{value || "NA"}</div>
                      </td>
                    ))}
                    {/* Fill empty cells if row is not full */}
                    {row.length < 3 && [...Array(3 - row.length)].map((_, i) => <td key={`empty-${i}`}></td>)}
                  </tr>
                ))}
              </>
            )}

            {/* Bank Details Section */}
            {!isInstitution && (
              <>
                <tr>
                  <td colSpan="3" className="pt-4 pb-2">
                    <h5 className="user-header mb-0 text-black">Bank Details</h5>
                  </td>
                </tr>
                {chunkedBankRows.map((row, rowIndex) => (
                  <tr key={`bank-${rowIndex}`} className="user-details-table-row-item">
                    {row.map(([label, value], colIndex) => (
                      <td key={colIndex} style={{ width: "33.33%" }} className="user-detail-cell py-3">
                        <h5 className="detail-label mb-2">{label}</h5>
                        <div className="detail-value">{value}</div>
                      </td>
                    ))}
                    {/* Fill empty cells if row is not full */}
                    {row.length < 3 && [...Array(3 - row.length)].map((_, i) => <td key={`empty-${i}`}></td>)}
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </Table>
      </Col>
    </Row>
  );
}
